import { DatePipe } from '@angular/common';
import { filter, find, orderBy, Many, ListIteratee } from 'lodash';
import { CITag } from '../clearance-item/clearance-item.model';

export class Guid {
    constructor(public guid: string) {
        this._guid = guid;
    }

    private _guid: string;

    public ToString(): string {
        return this.guid;
    }

    // Static member
    static MakeNew(): Guid {
        var result: string;
        var i: string;
        var j: number;

        result = "";
        for (j = 0; j < 32; j++) {
            if (j == 8 || j == 12 || j == 16 || j == 20)
                result = result + '-';
            i = Math.floor(Math.random() * 16).toString(16).toUpperCase();
            result = result + i;
        }
        return new Guid(result);
    }
}

export class DateUtils {
    static toDateFromString(dateToConvert: string,
        yearPosition: number,
        monthPosition: number,
        dayPosition: number,
        format: string = 'yyyy-MM-dd',
        separator: string): string {

        var datePipe = new DatePipe('en-US');

        if (!dateToConvert) {
            return dateToConvert;
        }

        let dateItems = dateToConvert.split(separator);
        if (dateItems.length != 3) {
            return dateToConvert;
        }

        let deadline = dateItems[monthPosition] + '/' + dateItems[dayPosition] + '/' + dateItems[yearPosition];

        let retValue = dateToConvert ? datePipe.transform(deadline, format) : deadline.toString();
        return retValue;
    }
    static tryToFormatStringToDateFormat(dateToConvert: string, returnFormat: string = 'yyyy-MM-dd') {
        //removed this code since it converts to date type any value that contains a dash or slash, for instance this will be converted to a data 'PDTC-1' = '2001-01-01'  :'( 
        // if (!isNaN(Date.parse(dateToConvert))){
        //     var datePipe = new DatePipe('en-US');
        //     return datePipe.transform(dateToConvert, returnFormat);
        // }
        return dateToConvert;
    }

     static toStringFromDateTime(date : Date): string {
     const stringDate =
        date.getFullYear().toString() +
      this.padZero(date.getMonth() + 1) +
      this.padZero(date.getDate()) +
      this.padZero(date.getHours()) +
      this.padZero(date.getMinutes()) +
      this.padZero(date.getSeconds());

      return stringDate;
    }

    private static padZero(value: number): string {
        return value < 10 ? `0${value}` : `${value}`;
    }
}

export class SharedUtils {
    static FixFlickering()
    {
        //observing flickering in Chrome 73 version
        //https://stackoverflow.com/questions/55147819/chrome-update-73-materialize-css-js-trigger-error
        //https://stackoverflow.com/questions/55200244/materialize-date-picker-automatically-hide-after-opening-problem-on-chrome/55461537#55461537
        //https://support.google.com/chrome/thread/3363391?hl=en
        $(document).on("click", ".select-wrapper", function (event) { event.stopPropagation(); });
        $('.picker__input').on('mousedown',function(event){
            event.preventDefault();
        })
    }

    static IsMobile(): Boolean {
        // window.mobileAndTabletcheck = function() {
        //     var check = false;
        //     (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        //     return check;
        //   };
        return /Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent) || window.innerWidth < 1025
    }
    static RemoveTooltipIfNeeded(notThis: string = '') {
        // window.mobileAndTabletcheck = function() {
        //     var check = false;
        //     (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        //     return check;
        //   };
        if (this.IsMobile()) {
            // console.log('removing material-tooltip...');
            // console.log('>>' + JSON.stringify($('.material-tooltip').val));
            $('.material-tooltip').not($(notThis)).remove();
            // console.log('>>' + JSON.stringify($('.material-tooltip').val));

        } else {
            // console.log('Won\'t remove material-tooltip...');
        }
    }


    static Sort<T>(array: T[], fields: Many<ListIteratee<T>>, ascdes: string = 'asc'): T[] {
        let ascdesc = 'asc';
        return orderBy(array, fields, [ascdesc]);
    }

    static FileTypeIsImage(fileType: string): boolean {
        const imagesTypes = new Set(["bmp", "gif", "jp2", "jpeg", "jpg", "png", "tif", "tiff", "webp"]);
        if (fileType.toLowerCase().startsWith("image"))
            return true;
        return imagesTypes.has(fileType.toLowerCase());
    }    
}

export class AppUtils {

    static SortTags(tags: CITag[]): CITag[]{
        
        let staticTags = tags.filter(t => t.tagType.toLowerCase() == 'static');
        staticTags = SharedUtils.Sort<CITag>(staticTags, [t => t.tagName.toLowerCase()]);
        let customTags = tags.filter(t => t.tagType.toLowerCase() == 'custom');
        customTags = SharedUtils.Sort<CITag>(customTags, [t => t.tagName.toLowerCase()]);

        return staticTags.concat(customTags);
    }

    static openInNewTemplate(): string{
        var template =
            `<!DOCTYPE html><html><head><title>{{IMAGE_NAME}}</title></head>
                <body style='margin: 2px; background-color: #e6e6e6; height: 99%;'><div style='text-align: center;'>
                <img id="imageId" src={{IMAGE_SOURCE}} 
                style='display: none;'/></div>
            </body></html>
            <script>
            var foreignHeight = {{DEVICE_HEIGHT}};
            var foreignWidth = {{DEVICE_WIDTH}};
            var image = document.getElementById('imageId');
            onload = (event) => {
                fillImageOnWindow();
            };
            window.addEventListener('resize', getSizes, false);
            image.addEventListener('load', (event) => {
                image.style.display = 'inline';
            });
            function getSizes() {
                if ((window.innerHeight/2)-(image.clientHeight/2)>0)
                    image.style.marginTop=(window.innerHeight/2)-(image.clientHeight/2)+'px';
                else
                    image.style.marginTop=0+'px';
            }
            function fillImageOnWindow(){   
                var deviceWidth = window.innerWidth * 0.99;
                var deviceHeight = window.innerHeight * 0.99;
                if (deviceWidth==0) deviceWidth = foreignWidth;
                if (deviceHeight==0) deviceHeight = foreignHeight;
                if(image && image.style) {
                    if (image.naturalWidth > image.naturalHeight){
                        if (image.naturalWidth > deviceWidth){
                            image.style.width = deviceWidth+'px';
                        }
                        if (image.clientHeight > deviceHeight){
                            image.style.width = null;
                            image.style.height = deviceHeight+'px';
                        }
                }
                    else{
                        if (image.naturalHeight > deviceHeight){
                            image.style.height = deviceHeight+'px';
                        }
                        if (image.clientWidth > deviceWidth){
                            image.style.height = null;
                            image.style.width = deviceWidth+'px';
                        }
                        
                    }
                    if (deviceHeight > image.clientHeight)
                    {
                        image.style.marginTop=(deviceHeight/2)-(image.clientHeight/2)+'px';
                    }
                }
            }
        </script>`;
        return template;
    }

    static padLeft(str: string, length: number, padChar: string = '0'): string {
        while (str.length < length) 
        {
          str = padChar + str;
        }
        return str;
    }

    static replaceQueryParam(url: string, param: string, newValue: string): string {
        const regex = new RegExp(`([?&])${param}=([^&]*)`, 'i');
        if (regex.test(url)) {
            return url.replace(regex, `$1${param}=${newValue}`);
        } else {
            return url.includes('?') ? `${url}&${param}=${newValue}` : `${url}?${param}=${newValue}`;
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/utils.ts